import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Fade,
  FormControl,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import withWidth from "@material-ui/core/withWidth";
import { CheckBox, CheckBoxOutlineBlank } from "@material-ui/icons";
import { withStyles } from "@material-ui/styles";
import { css } from "emotion";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import FullScreenDialog from "../../../components/FormDialog/FormDialog";
import { handleError } from "../../../components/Utils/Utils";
import RoleService from "../../../Services/RoleService/RoleService";
import RoleStore from "../../../Store/RoleStore";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
  itemModule: {
    background: "#4791db",
    marginTop: "10px",
    padding: "10px",
    position: "relative",
  },
  itemModuleCheckAll: {
    position: "absolute",
    right: "0",
    top: "0",
    fontSize: "smaller",
  },
});

function StyledCheckbox(props) {
  return (
    <Checkbox
      disableRipple
      style={{ width: 36, height: 36 }}
      icon={<CheckBoxOutlineBlank style={{ fontSize: 20 }} />}
      checkedIcon={<CheckBox style={{ fontSize: 20 }} />}
      inputProps={{ "aria-label": "decorative checkbox" }}
      {...props}
    />
  );
}

function Form(props) {
  const { classes, width, data, cancel } = props;
  const [openDialog, setOpenDialog] = React.useState(true);
  const [componentDidUpdate, setComponentDidUpdate] = React.useState(false);
  const [roleState, roleActions] = RoleStore();
  const [isLoadingForm, setIsLoadingForm] = React.useState(false);

  const [state, setState] = React.useState({
    formData: {
      id: "",
      level: "",
      name: "",
      default_page: "",
      type: "",
      is_admin: false,
      modules: [],
    },
  });

  const { formData } = state;
  const [modulesArray, setModulesArray] = React.useState([]);
  const arrAccess = ["create", "read", "update", "delete", "patch"];

  const checkedOnEdit = (dataModules) => {
    modulesArray.map((module, keyModule) => {
      const indexModule = dataModules.findIndex(
        (dataModuleObj) => dataModuleObj.id === module.id
      );

      if (indexModule >= 0) {
        const newModulesArray = [...modulesArray];
        if (
          dataModules[indexModule].features.length === module.features.length
        ) {
          newModulesArray[keyModule].checked = true;

          module.features.map((feature, keyFeature) => {
            const indexFeature = dataModules[indexModule].features.findIndex(
              (dataFeatureObj) => dataFeatureObj.id === feature.id
            );
            if (indexFeature >= 0) {
              let accessTrue = 0;
              arrAccess.map((access) => {
                if (
                  dataModules[indexModule].features[indexFeature][access] ===
                  true
                ) {
                  accessTrue++;
                }
                newModulesArray[keyModule].features[keyFeature][access] =
                  dataModules[indexModule].features[indexFeature][access];
              });

              if (accessTrue === arrAccess.length) {
                newModulesArray[keyModule].features[keyFeature].access = true;
              }
            }
            return (newModulesArray[keyModule].features[
              keyFeature
            ].checked = true);
          });
        } else {
          let arrFeatures = [];
          module.features.map((feature) => {
            let featureChecked = dataModules[indexModule].features.filter(
              (dataFeatureObj) => dataFeatureObj.id === feature.id
            );
            if (featureChecked.length > 0) {
              arrFeatures.push(featureChecked);
            }
          });

          arrFeatures.map((feature) => {
            const indexFeature = newModulesArray[keyModule].features.findIndex(
              (dataFeatureObj) => dataFeatureObj.id === feature[0].id
            );
            if (indexFeature >= 0) {
              let accessTrue = 0;
              arrAccess.map((access) => {
                if (feature[0][access] === true) {
                  accessTrue++;
                }
                newModulesArray[keyModule].features[indexFeature][access] =
                  feature[0][access];
              });
              if (accessTrue === arrAccess.length) {
                newModulesArray[keyModule].features[indexFeature].access = true;
              }
              return (newModulesArray[keyModule].features[
                indexFeature
              ].checked = true);
            }
          });
        }
        return setModulesArray(newModulesArray);
      }
    });
  };

  React.useEffect(() => {
    if (!openDialog) {
      var query = {
        num: "10",
        cursor: "",
        position: "",
        search: "",
      };
      roleActions.get(query);
      setComponentDidUpdate(false);
    }

    if (openDialog) {
      var query = {
        num: "10",
        cursor: "",
        position: "",
        search: "",
      };
      roleActions.getModulelist(query);
      setModulesArray(roleState.module);
      setIsLoadingForm(true);
      setComponentDidUpdate(true);
    }
  }, [openDialog]);

  React.useEffect(() => {
    if (componentDidUpdate) {
      if (data) {
        RoleService.getDataRole({ id: data.id })
          .then((response) => {
            setIsLoadingForm(false);
            setState({
              formData: response.data,
            });
            checkedOnEdit(response.data.modules);
          })
          .catch((error) => {
            handleError(error);
          });
      } else {
        setIsLoadingForm(false);
      }
    }
  }, [componentDidUpdate]);

  const handleCheckedAll = (event, id, key) => {
    //cari apakah sudah ada module_id yang sama, jika belum push
    const newModulesArray = [...modulesArray];
    newModulesArray[key].checked = event.target.checked;

    if (event.target.checked) {
      let arrFeatures = [];
      modulesArray[key].features.map((feature, keyFeature) => {
        let featureObj = { ...feature };
        arrAccess.map((access) => {
          return (featureObj[access] = featureObj[access]
            ? featureObj[access]
            : false);
        });
        delete featureObj.checked;
        arrFeatures.push(featureObj);
        return (newModulesArray[key].features[keyFeature].checked = true);
      });

      if (formData["modules"]) {
        const checkModule = formData["modules"].filter(
          (moduleObj) => moduleObj.id === id
        );

        if (checkModule.length === 0) {
          let module = { ...newModulesArray[key] };
          module.features = arrFeatures;
          delete module.checked;
          formData["modules"].push(module);
        } else {
          const moduleIndex = formData["modules"].findIndex(
            (moduleObj) => moduleObj.id === id
          );

          formData["modules"][moduleIndex].features = arrFeatures;
        }
      } else {
        formData["modules"] = [];
        let module = { ...newModulesArray[key] };
        module.features = arrFeatures;
        delete module.checked;
        formData["modules"].push(module);
      }
    } else {
      modulesArray[key].features.map((feature, keyFeature) => {
        newModulesArray[key].features[keyFeature].access = false;
        arrAccess.map((access) => {
          newModulesArray[key].features[keyFeature][access] = false;
        });
        return (newModulesArray[key].features[keyFeature].checked = false);
      });
      formData["modules"] = formData["modules"].filter(
        (moduleObj) => moduleObj.id !== id
      );
    }
    setState({ ...state, formData });
    setModulesArray(newModulesArray);
  };

  const handleChecked = (event, dataFeature, dataModule, key, keyModule) => {
    const newModulesArray = [...modulesArray];
    newModulesArray[keyModule].features[key].checked = event.target.checked;

    if (!formData["modules"]) {
      formData.modules = [];
    }

    if (event.target.checked) {
      const checkModule = formData["modules"].filter(
        (moduleObj) => moduleObj.id === dataModule.id
      );

      if (checkModule.length === 0) {
        let moduleObj = { ...dataModule };
        delete moduleObj.checked;
        let featureObj = { ...dataFeature };
        arrAccess.map((access) => {
          return (featureObj[access] = featureObj[access]
            ? featureObj[access]
            : false);
        });

        delete featureObj.checked;
        moduleObj.features = [featureObj];

        formData["modules"].push(moduleObj);
      } else {
        const moduleIndex = formData["modules"].findIndex(
          (moduleObj) => moduleObj.id === dataModule.id
        );

        let featureObj = { ...dataFeature };
        arrAccess.map((access) => {
          return (featureObj[access] = featureObj[access]
            ? featureObj[access]
            : false);
        });
        delete featureObj.checked;
        formData["modules"][moduleIndex].features.push(featureObj);
      }
    } else {
      const moduleIndex = formData["modules"].findIndex(
        (moduleObj) => moduleObj.id === dataModule.id
      );

      if (moduleIndex >= 0) {
        formData["modules"][moduleIndex].features = formData["modules"][
          moduleIndex
        ].features.filter((featureObj) => featureObj.id !== dataFeature.id);

        // reset check access
        newModulesArray[keyModule].features[key].access = false;
        arrAccess.map((access) => {
          return (newModulesArray[keyModule].features[key][access] = false);
        });

        // uncheck module checkall
        newModulesArray[keyModule].checked = false;
        if (formData["modules"][moduleIndex].features.length === 0) {
          formData["modules"].splice(moduleIndex, 1);
        }
      }
    }
    setState({ ...state, formData });
    setModulesArray(newModulesArray);
  };

  const handleCheckedAccess = (
    event,
    accessId,
    featureId,
    moduleId,
    key,
    keyModule
  ) => {
    const newModulesArray = [...modulesArray];
    newModulesArray[keyModule].features[key][accessId] = event.target.checked;
    const moduleIndex = formData["modules"].findIndex(
      (moduleObj) => moduleObj.id === moduleId
    );

    if (moduleIndex >= 0) {
      const featureIndex = formData["modules"][moduleIndex].features.findIndex(
        (featureObj) => featureObj.id === featureId
      );

      if (featureIndex >= 0) {
        formData["modules"][moduleIndex].features[featureIndex][accessId] =
          event.target.checked;
      }
    }

    if (!event.target.checked) {
      newModulesArray[keyModule].features[key].access = false;
    }

    setState({ ...state, formData });
    setModulesArray(newModulesArray);
  };

  const handleCheckedAllAccess = (
    event,
    featureId,
    moduleId,
    key,
    keyModule
  ) => {
    const newModulesArray = [...modulesArray];
    newModulesArray[keyModule].features[key].access = event.target.checked;

    arrAccess.map((access) => {
      handleCheckedAccess(event, access, featureId, moduleId, key, keyModule);
    });

    setModulesArray(newModulesArray);
  };

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };

  const handleChangeSwitch = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.checked;
    setState({ formData });
  };

  const handleSubmit = (event) => {
    confirm("Submit", "Are you sure to Submit ?").then(async (onProcess) => {
      if (props.data === null) {
        const { formData } = state;
        await roleActions.store(formData);
        handleCloseDialog();
        cancel();
      } else {
        const { formData } = state;
        await roleActions.put(formData);
        handleCloseDialog();
        cancel();
      }
    });
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setIsLoadingForm(false);
  };

  return (
    <FullScreenDialog
      maxWidth={width !== "xs" ? "md" : false}
      fullScreen={width === "xs"}
      title={props.title}
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent dividers>
        {isLoadingForm ? (
          <Grid container justify="center">
            <Grid container justify="center" item xs={width === "lg" ? 8 : 12}>
              <Fade
                in={isLoadingForm}
                style={{
                  transitionDelay: isLoadingForm ? "200ms" : "0ms",
                }}
                unmountOnExit
              >
                <CircularProgress />
              </Fade>
            </Grid>
          </Grid>
        ) : (
          <ValidatorForm
            id="myform"
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <Grid container justify="center">
              <Grid
                container
                justify="center"
                item
                xs={width === "lg" ? 8 : 12}
              >
                <Typography
                  variant="subtitle1"
                  className={classes.header}
                  gutterBottom
                >
                  Please input role management:
                </Typography>
                <TextValidator
                  id="name"
                  label="Name"
                  name="name"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  value={state.formData.name}
                  validators={["required"]}
                  errorMessages={["Name is required"]}
                  onChange={handleChange}
                  autoFocus
                />
                <TextValidator
                  id="default_page"
                  label="Default Page"
                  name="default_page"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  value={state.formData.default_page}
                  validators={["maxStringLength: 100"]}
                  errorMessages={["Maximum character length is 100"]}
                  onChange={handleChange}
                />
                <FormControl
                  variant="outlined"
                  className={css`
                    min-width: 100% !important;
                  `}
                  margin="normal"
                  required
                >
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type"
                    value={state.formData.type}
                    onChange={handleChange}
                    label="Type"
                    inputProps={{
                      name: "type",
                      id: "type",
                    }}
                  >
                    <MenuItem value="group">Group (IZY)</MenuItem>
                    <MenuItem value="brand">Brand</MenuItem>
                    <MenuItem value="mall">Property - Mall</MenuItem>
                    <MenuItem value="hotel">Property - Hotel</MenuItem>
                    <MenuItem value="residential">Property - Residential</MenuItem>
                    <MenuItem value="tenant">Tenant</MenuItem>
                  </Select>
                </FormControl>
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.formData.is_admin}
                      onChange={handleChangeSwitch}
                      name="is_admin"
                      color="primary"
                    />
                  }
                  label="Admin ?"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.formData.is_courier}
                      onChange={handleChangeSwitch}
                      name="is_courier"
                      color="primary"
                    />
                  }
                  label="Property Courier ?"
                />
              </Grid>

              <Grid
                container
                justify="center"
                item
                xs={width === "lg" ? 8 : 12}
              >
                <Box mt={2}>
                  <Typography
                    variant="subtitle1"
                    className={classes.header}
                    gutterBottom
                  >
                    Role Management
                  </Typography>
                </Box>
              </Grid>

              <Grid container item xs={width === "lg" ? 8 : 12}>
                <Box mt={2} style={{ width: "inherit" }}>
                  <FormGroup column="true">
                    {modulesArray.map((module, keyModule) => {
                      return (
                        <div key={module.id}>
                          <Typography
                            key={keyModule}
                            className={classes.itemModule}
                          >
                            {module.name}
                            <FormControlLabel
                              className={classes.itemModuleCheckAll}
                              control={
                                <Checkbox
                                  checked={module.checked === true}
                                  onChange={(event) =>
                                    handleCheckedAll(
                                      event,
                                      module.id,
                                      keyModule
                                    )
                                  }
                                  name={`modules-${module.id}`}
                                />
                              }
                              label="Select All"
                              labelPlacement="end"
                            />
                          </Typography>

                          <Grid container justify="flex-start">
                            {module.features.map((feature, keyFeature) => {
                              return (
                                <Grid
                                  container
                                  item
                                  xs={width === "lg" ? 4 : 12}
                                  md={width === "lg" ? 4 : 6}
                                  key={keyFeature}
                                >
                                  <FormControlLabel
                                    key={keyFeature}
                                    control={
                                      <Checkbox
                                        checked={feature.checked === true}
                                        onChange={(event) =>
                                          handleChecked(
                                            event,
                                            feature,
                                            module,
                                            keyFeature,
                                            keyModule
                                          )
                                        }
                                        name={`features-${module.id}-${feature.id}`}
                                      />
                                    }
                                    label={feature.name}
                                  />
                                  {feature.checked === true && (
                                    <Fade in={feature.checked === true}>
                                      <Grid
                                        container
                                        justify="flex-start"
                                        style={{ paddingLeft: "12px" }}
                                      >
                                        <Grid container item xs={12}>
                                          <FormControlLabel
                                            value="end"
                                            control={
                                              <StyledCheckbox
                                                color="default"
                                                name={`access-${module.id}-${feature.id}-access`}
                                                checked={
                                                  feature.access === true
                                                }
                                                onChange={(event) =>
                                                  handleCheckedAllAccess(
                                                    event,
                                                    feature.id,
                                                    module.id,
                                                    keyFeature,
                                                    keyModule
                                                  )
                                                }
                                              />
                                            }
                                            label={
                                              <span
                                                style={{
                                                  fontSize: "0.8rem",
                                                  textTransform: "capitalize",
                                                }}
                                              >
                                                Select All Access
                                              </span>
                                            }
                                            labelPlacement="end"
                                          />
                                        </Grid>
                                        <Grid
                                          container
                                          item
                                          xs={width === "lg" ? 2 : 6}
                                          style={{ paddingLeft: "10px" }}
                                        >
                                          {arrAccess.map((access) => {
                                            return (
                                              <FormControlLabel
                                                key={`key-${module.id}-${feature.id}-${access}`}
                                                value="end"
                                                control={
                                                  <StyledCheckbox
                                                    color="primary"
                                                    name={`access-${module.id}-${feature.id}-${access}`}
                                                    checked={
                                                      feature[access] === true
                                                    }
                                                    onChange={(event) =>
                                                      handleCheckedAccess(
                                                        event,
                                                        access,
                                                        feature.id,
                                                        module.id,
                                                        keyFeature,
                                                        keyModule
                                                      )
                                                    }
                                                  />
                                                }
                                                label={
                                                  <span
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      textTransform:
                                                        "capitalize",
                                                    }}
                                                  >
                                                    {access}
                                                  </span>
                                                }
                                                labelPlacement="end"
                                              />
                                            );
                                          })}
                                        </Grid>
                                      </Grid>
                                    </Fade>
                                  )}
                                </Grid>
                              );
                            })}
                          </Grid>
                        </div>
                      );
                    })}
                  </FormGroup>
                </Box>
              </Grid>
            </Grid>
          </ValidatorForm>
        )}
      </DialogContent>
      <DialogActions>
        {!isLoadingForm && (
          <React.Fragment>
            <Button
              onClick={() => {
                handleCloseDialog();
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              form="myform"
              variant="contained"
              style={{ marginRight: 30 }}
              color="primary"
            >
              Submit
            </Button>
          </React.Fragment>
        )}
      </DialogActions>
    </FullScreenDialog>
  );
}

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function submitForm(title, data, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      ...options,
    }
  );
}
